import { render, staticRenderFns } from "./synthesize-form.html?vue&type=template&id=4b0c5f4a&scoped=true&external"
import script from "./synthesize-form.js?vue&type=script&lang=js&external"
export * from "./synthesize-form.js?vue&type=script&lang=js&external"
import style0 from "./synthesize-form.scss?vue&type=style&index=0&id=4b0c5f4a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0c5f4a",
  null
  
)

export default component.exports